import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ProgramAdvancedSearchModalArgument } from './program-advanced-search-modal.argument';
import { ProgramAdvancedSearchModalComponent } from './program-advanced-search-modal.component';

@Injectable({
	providedIn: 'root',
})
export class ProgramAdvancedSearchModalService {
	constructor(private modalService: NgbModal) {}

	public openModal$(
		args: ProgramAdvancedSearchModalArgument,
	): Observable<number[] | number> {
		return new Observable<number[] | number>((o) => {
			const ngbModalOptions: NgbModalOptions = {
				backdrop: 'static',
				size: 'lg',
				scrollable: true,
			};
			const modal = this.modalService.open(
				ProgramAdvancedSearchModalComponent,
				ngbModalOptions,
			);

			(
				modal.componentInstance as ProgramAdvancedSearchModalComponent
			).bindModalData({
				multi: args.multi,
				organizations$: args.organizations$,
				includeDeactivated: args?.includeDeactivated,
				includeStructural: args?.includeStructural,
				selectedOrgs: args?.selectedOrgs,
				maxSelectedItems: args?.maxSelectedItems,
				showDeactivatedIncludedOnly: args?.showDeactivatedIncludedOnly,
				selectionRequired: args?.selectionRequired,
			});

			modal.result
				.then((ids) => {
					o.next(ids);
					o.complete();
				})
				.catch(() => {
					o.complete();
				});
		});
	}
}
